import React, { createContext, useContext, useMemo } from 'react';

import { useDrawerStateStore } from '@stores/drawer';

type WebNavigationContainerContext = {
  openDrawer: () => void;
  closeDrawer: () => void;
  isOpen: boolean;
};

const WebNavigationContainerContext =
  createContext<WebNavigationContainerContext>({
    openDrawer: () => {},
    closeDrawer: () => {},
    isOpen: false,
  });

type WebNavigationContainerProps = {
  children: React.ReactNode;
};
export const WebNavigationContainer: React.FC<WebNavigationContainerProps> = ({
  children,
}) => {
  const { set, isOpen } = useDrawerStateStore();

  const value: WebNavigationContainerContext = useMemo(
    () => ({
      openDrawer: () => set(true),
      closeDrawer: () => set(false),
      isOpen,
    }),
    [isOpen, set],
  );

  return (
    <WebNavigationContainerContext.Provider value={value}>
      {children}
    </WebNavigationContainerContext.Provider>
  );
};

export const useWebNavigationContainer = () =>
  useContext(WebNavigationContainerContext);
